/**
 * Dispatch Custom Event on Window
 *
 * @param {string} name - event name
 * @param {*} detail - event details
 * @param {EventInit} options - event options, defults {cancelable: false, bubbles: false}
 */
export const dispatchCustomEvent = (
    name: string,
    detail: unknown = {},
    options: EventInit = {bubbles: false, cancelable: false},
) => {
    window.dispatchEvent(
        new CustomEvent(name, {
            bubbles: options.bubbles,
            cancelable: options.cancelable,
            detail,
        }),
    );
};
